var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curve-shape"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 3841 120"},attrs:{"x":"0px","y":"0px","viewBox":"0 0 3841 120","xml:space":"preserve"}},[_vm._t("bgcolor")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }